import React, { useEffect, useRef, useState } from "react";
import ReactTooltip from "react-tooltip";

export const RecommendationBand = ({
    label,
    bandId,
    handleBandClick,
    MainFields,
    RestFields,
    showBand,
    isDefaultOpen,
    ExtraFields,
    filteredCount,
    isSurveyAsset = false,
    fillEmptyFields,
    showFillEmptyField = false,
    isStaticBand,
    isInaccessible,
    headerClassName = "",
    hidden = false
}) => {
    const [isCollapsed, setIsCollapsed] = useState(isInaccessible ? !isInaccessible : !showBand?.[bandId]);
    const collapseRef = useRef(null);

    useEffect(() => {
        const observer = new MutationObserver(mutationsList => {
            for (let mutation of mutationsList) {
                if (mutation.attributeName === "class") {
                    const isShowClass = mutation.target.classList.contains("show");
                    setIsCollapsed(!isShowClass);
                }
            }
        });

        const currentCollapseRef = collapseRef.current;

        if (currentCollapseRef) {
            observer.observe(currentCollapseRef, { attributes: true });
        }

        return () => {
            if (currentCollapseRef) {
                observer.disconnect();
            }
        };
    }, [bandId]);
    // const bandId = band || label?.toLowerCase()?.split(" ").join("_");
    if (hidden) return null;
    return (
        <div className={`card ${isStaticBand ? "mb-2 pr-0" : ""}`}>
            <ReactTooltip id="empty-fields" effect="solid" place="top" backgroundColor="#007bff" className="rc-tooltip-custom-class" />
            <div className="card-header" id={"heading" + bandId}>
                <div className={`otr-recom-div ${headerClassName ? `${headerClassName}` : ""}`}>
                    <button
                        className="btn btn-link"
                        data-toggle="collapse"
                        data-target={`#${bandId}`}
                        aria-expanded={isInaccessible || showBand?.[bandId] ? "true" : "false"}
                        aria-controls={bandId}
                        onClick={event => {
                            event.preventDefault();
                            handleBandClick(bandId, !showBand?.[bandId]);
                        }}
                        disabled={isStaticBand}
                    >
                        {label}
                        {filteredCount > 0 && <span className="badge-outer">{filteredCount}</span>}
                    </button>
                    {showFillEmptyField && (
                        <div class="button-edit-wrap">
                            <button
                                onClick={e => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    fillEmptyFields();
                                }}
                                className="btn-out-save ml-2"
                                data-for="empty-fields"
                                data-tip="Populate all empty text fields with the value: NA"
                            >
                                <i className="fas fa-edit "></i>
                            </button>
                        </div>
                    )}

                    {MainFields}
                </div>
            </div>
            <div
                id={bandId}
                ref={collapseRef}
                className={isInaccessible || showBand?.[bandId] ? "collapse show" : "collapse"}
                aria-labelledby={"heading" + bandId}
            >
                <div className="card-body">
                    {!isCollapsed && <div className="outer-rcm mt-1">{RestFields}</div>}
                    {ExtraFields}
                </div>
            </div>
        </div>
    );
};
